<template>
    <v-dialog
        v-model="dialogVisible"
        max-width="550"
        persistent
    >
        <v-card :color="isThemeAja ? '#1E3945' : ''">
            <!-- Header -->
            <v-card-title
                :class="['py-4', isThemeAja ? 'aja-header' : 'primary']"
                class="white--text"
            >
                <v-icon class="mr-3 white--text">event_note</v-icon>
                <span class="title">Rappel important</span>
            </v-card-title>

            <!-- Message principal -->
            <v-card-text
                :class="[
                    'pt-5 pb-4 px-5 subtitle-1',
                    {'white--text': $vuetify.theme.dark || isThemeAja, 'black--text': !$vuetify.theme.dark && !isThemeAja}
                ]"
            >
                <v-alert
                    :color="isThemeAja ? '#4E983C' : 'primary'"
                    border="left"
                    colored-border
                    elevation="1"
                    dense
                    :style="isThemeAja ? {'background-color': '#294D5B'} : {}"
                >
                    <div class="d-flex align-start">
                        <v-icon :color="isThemeAja ? '#4E983C' : 'primary'" class="mr-3 mt-1">info</v-icon>
                        <div class="body-1">
                            Pensez à réserver une douzaine de RDV sur votre atelier de référence,
                            vous pourrez annuler votre RDV jusqu'à 48h à l'avance si besoin.
                        </div>
                    </div>
                </v-alert>
            </v-card-text>

            <v-divider></v-divider>

            <!-- Actions -->
            <v-card-actions class="pa-4 justify-center">
                <v-btn
                    :color="isThemeAja ? '#4E983C' : 'primary'"
                    dark
                    @click="close"
                >
                    <v-icon left>check</v-icon>
                    J'ai compris
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'SessionReminderPopup',
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters(['isThemeAja']),
        dialogVisible: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        close() {
            this.dialogVisible = false
        }
    }
}
</script>

<style scoped>
.aja-header {
    background-color: #4E983C !important;
}
</style>
